import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import type { NavKey } from "@/app/navigation";
import { EmptyState } from "@/components/common/EmptyState";
import { PageHeader } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

type ComingSoonPageProps = {
  section: NavKey;
  stage: number;
};

/** Placeholder for sections scheduled in later roadmap stages. */
export function ComingSoonPage({ section, stage }: ComingSoonPageProps) {
  const { t } = useTranslation();
  const name = t(`nav.${section}`);

  return (
    <>
      <PageHeader title={name} />
      <Card>
        <EmptyState
          icon={Construction}
          title={t("comingSoon.title")}
          description={t("comingSoon.description", { section: name, stage })}
          action={
            <Button asChild variant="secondary">
              <Link to="/">{t("comingSoon.back")}</Link>
            </Button>
          }
        />
      </Card>
    </>
  );
}
